const newContainer = () => import("@/layouts/Default.vue");
const routerParrent = () => import("@/layouts/routerParrent.vue");

const searchEvidence = () => import("../views/evidence/searchEvidence.vue");

const addEvidence = () =>
  import("../views/evidence/components/addEvidence.vue");

const editEvidence = () =>
  import("../views/evidence/components/editEvidence.vue");

const competencyList = () => import("../views/competency/competentcyList.vue");

const indicatorList = () => import("../views/indicator/indicatorList.vue");
const exerciseList = () => import("../views/exercise/exerciseList.vue");

const templateList = () => import("../views/template/templateList.vue");

const assessmentPlanList = () =>
  import("../views/assessmentPlan/assessmentPlanList.vue");

const editAssessmentPlan = () =>
  import("../views/assessmentPlan/components/editAssessmentPlan.vue");

const pseudoAssessmentCalendar = () =>
  import("../views/assessmentPlan/components/pseudoAssessmentCalendar.vue");
const competencyExerciseMatrix = () =>
  import("../views/template/components/competencyExerciseMatrix.vue");

const centerExecutePlannerList = () =>
  import("../views/centerExecutePlanner/centerExecutePlannerList.vue");

const myCenterExecuteList = () =>
  import("../views/myCenterExecuteList/myCenterExecuteList.vue");

const centerExecuteEdit = () =>
  import("../views/centerExecute/centerExecuteEdit/centerExecuteEdit.vue");

const endedCenterExecute = () =>
  import("../views/endedCenterExecuteList/endedCenterExecuteList.vue");

const centerExecuteList = () =>
  import("../views/centerExecute/centerExecuteList.vue");

const listCenterExecuteCases = () =>
  import("../views/centerExecuteCases/listCenterExecuteCases.vue");
const meetingBoard = () => import("../views/meeting-board/meetingBoard.vue");
const completeInfoList = () =>
  import("../views/complete-info/completeInfoList.vue");
const centerExecuteAccessList = () =>
  import("../views/center-execute-access/centerExecuteAccessList.vue");

const centerExecuteCaseCompetency = () =>
  import(
    "../views/centerExecuteCaseCompetency/centerExecuteCaseCompetency.vue"
  );

const centerExecutePlannerEdit = () =>
  import("../views/centerExecutePlanner/centerExecutePlannerEdit.vue");

const listWashup = () => import("../views/washup/listWashup.vue");

const editWashup = () => import("../views/washup/editWashup.vue");

const competencyOverview = () =>
  import("../views/washup/competencyOverview.vue");
const indicatorReferencesList = () =>
  import("../views/indicator-references/indicatorReferencesList.vue");

export const kanoonRoutes: any[] = [
  {
    path: "/ac",
    redirect: "/dashboard",
    name: "kanoon",
    meta: {
      label: "خانه",
      moduleName: "kanoon",
    },
    component: newContainer,
    children: [
      {
        path: "assessment_plan",
        name: "assessment_plan",
        redirect: "/ac/assessment_plan/list",
        component: routerParrent,
        meta: {
          label: "برنامه ارزیابی",
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "searchAssessment_plan",
            component: assessmentPlanList,
            meta: {
              label: "برنامه‌های ارزیابی",
              redesigned: true,
            },
          },
          {
            path: "edit/:id",
            name: "editAssessmentPlan",
            component: editAssessmentPlan,
            meta: {
              redesigned: true,
              label: "ویرایش برنامه ارزیابی",
              hasBottomNavigation: false,
            },
          },
          {
            path: "pseudo_data/:id",
            name: "pseudoCalendar",
            component: pseudoAssessmentCalendar,
            meta: {
              redesigned: true,
              label: "تقویم برنامه ارزیابی",
              hasBottomNavigation: false,
            },
          },
        ],
      },
      {
        path: "center-execute-planner",
        name: "center_execute_with_access",
        redirect: "/ac/center-execute-planner/list",
        component: routerParrent,
        meta: {
          label: "کانون",
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "center-execute-planner",
            component: centerExecutePlannerList,
            meta: {
              label: "برنامه‌ریز کانون",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":centerExecuteCode/edit",
            name: "center-execute-planner-edit",
            component: centerExecutePlannerEdit,
            meta: {
              label: "ویرایش افراد کانون",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":centerExecuteCode/cases",
            name: "center-execute-planner-cases",
            component: listCenterExecuteCases,
            meta: {
              label: "پرونده‌های کانون",
              redesigned: true,
            },
          },
          {
            path: ":centerExecuteCode/cases/:caseId/competency",
            name: "center-execute-planner-case-competency",
            component: centerExecuteCaseCompetency,
            meta: {
              hasBottomNavigation: false,
              label: "علامت گذاری شایستگی",
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "center-execute-access",
        name: "center_execute_access",
        redirect: "/ac/center-execute-access/list",
        component: routerParrent,
        meta: {
          label: "کانون",
        },
        children: [
          {
            path: "list",
            name: "center-execute-access",
            component: centerExecuteAccessList,
            meta: {
              label: "دسترسی برنامه‌ریز کانون",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "center-execute/my",
        name: "my_center_execute",
        component: myCenterExecuteList,
        meta: {
          redesigned: true,
          requiresAuth: true,
          label: "کانون‌های من",
        },
      },
      {
        path: "center-execute/ended",
        name: "ended_center_execute",
        component: endedCenterExecute,
        meta: {
          redesigned: true,
          label: "کانون‌های پایان یافته",
        },
      },
      {
        path: "center-execute/cases",
        name: "all_center_execute_case",
        component: listCenterExecuteCases,
        meta: {
          label: "کل پرونده‌های کانون",
          redesigned: true,
        },
      },

      {
        path: "center-execute/:centerExecuteCode/cases",
        name: "center-execute-cases",
        component: listCenterExecuteCases,
        meta: {
          label: "پرونده‌های کانون",
          redesigned: true,
        },
      },
      {
        path: "center-execute",
        name: "center_execute",
        redirect: "/ac/center-execute/all",
        component: routerParrent,
        meta: {
          label: "کانون",
          redesigned: true,
          requiresAuth: true,
        },
        children: [
          {
            path: "all",
            name: "center-execute-list",
            component: centerExecuteList,
            meta: {
              label: "کانون‌های جاری",
              redesigned: true,
              requiresAuth: true,
            },
          },
          {
            path: ":centerExecuteCode/cases/:caseId/competency",
            name: "center-execute-case-competency",
            component: centerExecuteCaseCompetency,
            meta: {
              hasBottomNavigation: false,
              label: "علامت گذاری شایستگی",
              redesigned: true,
            },
          },
          {
            path: ":centerExecuteCode/edit",
            name: "center-execute-edit",
            component: centerExecuteEdit,
            meta: {
              hasBottomNavigation: false,
              label: "ویرایش کانون",
              redesigned: true,
            },
          },
          {
            path: ":centerExecuteCode/washup",
            name: "washup",
            component: routerParrent,
            meta: {
              label: "جمع‌بندی",
              redesigned: true,
            },
            children: [
              {
                path: "list",
                name: "list-washup",
                component: listWashup,
                meta: {
                  label: "وضعیت پرونده‌ها",
                  redesigned: true,
                  hasMaxWidth: false,
                },
              },
              {
                path: "competency-overview",
                name: "washup-competency-overview",
                component: competencyOverview,
                meta: {
                  label: "جمع‌بندی شایستگی",
                  redesigned: true,
                  hasMaxWidth: false,
                },
              },
              {
                path: ":candidateId/edit",
                name: "edit-washup",
                component: editWashup,
                meta: {
                  label: "ویرایش جمع‌بندی",
                  hasMaxWidth: false,
                  redesigned: true,
                },
              },
            ],
          },
        ],
      },
      {
        path: "competency",
        redirect: "/ac/competency/search",
        name: "competency",
        component: routerParrent,
        meta: {
          label: "شایستگی",
          redesigned: true,
        },
        children: [
          {
            path: "search",
            name: "competencyList",
            component: competencyList,
            meta: {
              label: "شایستگی‌ها",
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "indicator",
        name: "indicator",
        redirect: "/ac/indicator/list",
        component: routerParrent,
        meta: {
          label: "نشانگر",
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "indicatorList",
            component: indicatorList,
            meta: {
              redesigned: true,
              label: "جستجوی نشانگر",
            },
          },
        ],
      },
      {
        path: "template",
        name: "template",
        redirect: "/ac/template/list",
        component: routerParrent,
        meta: {
          label: "قالب",
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "templateList",
            component: templateList,
            meta: {
              label: "جستجوی قالب",
              redesigned: true,
            },
          },
          {
            path: "competency-exercise-matrix/:id",
            name: "competencyExerciseMatrix",
            component: competencyExerciseMatrix,
            meta: {
              label: "ماتریس تمرین-شایستگی",
              redesigned: true,
              hasBottomNavigation: false,
              hasMaxWidth: false,
            },
          },
        ],
      },
      {
        path: "evidence",
        name: "evidence",
        redirect: "/ac/evidence/search",
        component: routerParrent,
        meta: {
          label: "مصادیق",
        },
        children: [
          {
            path: "search",
            name: "evidence-search",
            component: searchEvidence,
            meta: {
              label: "لیست مصادیق",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "add",
            name: "add-evidence",
            component: addEvidence,
            meta: {
              label: "مصداق جدید",
              requiresAuth: true,
              redesigned: true,
              hasBottomNavigation: false,
            },
          },
          {
            path: "edit/:id",
            name: "edit-evidence",
            component: editEvidence,
            meta: {
              label: "ویرایش مصداق",
              requiresAuth: true,
              redesigned: true,
              hasBottomNavigation: false,
            },
          },
        ],
      },
      {
        path: "meeting-board",
        name: "center_execute_meeting_board",
        component: meetingBoard,
        meta: {
          label: "دریافت فایل گزارش عملکرد ارزیابی",
          requiresAuth: true,
          redesigned: true,
        },
      },
      {
        path: "complete-info",
        name: "center_execute_complete_info",
        component: completeInfoList,
        meta: {
          label: "گزارش کامل کانون",
          requiresAuth: true,
          redesigned: true,
        },
      },
      {
        path: "exercise",
        name: "exercise",
        redirect: "/ac/exercise/list",
        component: routerParrent,
        meta: {
          label: "تمرین",
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "exercise-list",
            component: exerciseList,
            meta: {
              label: "لیست تمرین",
            },
          },
          {
            path: "add",
            name: "addExercise",
            // component: AddExercise,

            meta: {
              label: "ایجاد تمرین",
            },
          },
          {
            path: "edit/:id",
            name: "editExercise",
            // component: editExercise,
            meta: {
              label: "ویرایش تمرین",
            },
          },
          {
            path: "exerciseDesign/:id",
            name: "exerciseDesign",
            // component: exerciseDesignPage,
            meta: {
              label: "طراحی تمرین",
            },
          },
          {
            path: ":id/algorithm",
            name: "algorithm",
            redirect: "/ac/exercise/edit/:id",
            // component: routerParrent,
            meta: {
              label: "مراحل اجرای تمرین",
            },
            children: [
              {
                path: "search",
                name: "searchAlgorithm",
                // component: searchAlgorithm,
                meta: {
                  label: "جستجوی الگوریتم تمرین",
                },
              },
              {
                path: "add",
                name: "AddAlgorithm",
                // component: AddAlgorithm,
                meta: {
                  label: "الگوریتم تمرین",
                },
              },
              {
                path: "edit/:algorithm_id",
                name: "editAlgorithm",
                // component: editAlgorithm,
                meta: {
                  label: "جزئیات مرحله اجرای تمرین",
                },
              },
            ],
          },
        ],
      },
      {
        path: "indicator-reference",
        name: "indicator_reference",
        redirect: "/ac/indicator-reference/list",
        component: routerParrent,
        meta: {
          label: "مراجع شاخص ها",
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "indicator-reference-list",
            component: indicatorReferencesList,
            meta: {
              label: "لیست مراجع شاخص ها",
            },
          },
        ],
      },
    ],
  },
];
